module.exports = __webpack_public_path__ + "img/744.5c278c59.jpg";